var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22598",
    "data-name": "Group 22598",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.729,
    height: 18.582,
    viewBox: "0 0 13.729 18.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-location"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3617",
    "data-name": "Rectangle 3617",
    width: 13.729,
    height: 18.582,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22598-2",
    "data-name": "Group 22598",
    clipPath: "url(#clip-path-icon-location)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12288",
    "data-name": "Path 12288",
    d: "M6.864,0A6.872,6.872,0,0,0,0,6.864,7.92,7.92,0,0,0,.582,9.507a11.07,11.07,0,0,0,.793,1.484l4.706,7.131a.9.9,0,0,0,1.564,0l4.707-7.132a11.023,11.023,0,0,0,.793-1.484,7.918,7.918,0,0,0,.582-2.643A6.872,6.872,0,0,0,6.864,0M12.4,9.194a10.143,10.143,0,0,1-.723,1.353L6.972,17.678c-.093.141-.122.141-.215,0L2.05,10.546a10.147,10.147,0,0,1-.723-1.353A7.189,7.189,0,0,1,.808,6.864a6.057,6.057,0,0,1,12.113,0A7.2,7.2,0,0,1,12.4,9.194",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12289",
    "data-name": "Path 12289",
    d: "M67.634,64.008a3.634,3.634,0,1,0,3.634,3.634,3.638,3.638,0,0,0-3.634-3.634m0,6.46a2.826,2.826,0,1,1,2.826-2.826,2.83,2.83,0,0,1-2.826,2.826",
    transform: "translate(-60.77 -60.777)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.5edf2a639f0ebe01ae7b53272c9d5821.svg";
export { ForwardRef as ReactComponent };